import React from 'react'
import './Booking_Details_Card.css'
import { Link } from 'react-router-dom'

const Booking_Details_Card = ({
    orderId,
    onClick,
    no_of_items,
    date,
    data,
    showTrackOrder,
    type,
    price,
    subtext = "dddddddd",
    track_order_text,
    baseLike,
}) => {
    return (
        <section className="Booking_Details_Card">
            {/* TOP SECTION */}
            <div className="top_section">
                <p className="order_id">Room Name : {orderId}</p>

                <div className="date_text_div">
                    <p className="date_text">
                        check In :    {date || ""}
                    </p>
                </div>
            </div>

            {/* MIDDLE SECTION */}
            <div className="middle_section">
                <p className="black_text">{no_of_items} Nights</p>

                {showTrackOrder && (
                    <p className="track_order_text" onClick={onClick}>
                        {track_order_text} iiiasopidhasiodhasoidh
                    </p>
                )}
            </div>

            {/* BOTTOM SECTION */}
            <div className="bottom_section">
                <p className="black_text">
                    ₹.{price}{" "}
                    <span className={`${type} subtext`}>
                        {subtext}
                    </span>
                </p>

                <Link to={baseLike}>
                    <p className="view_details_text">View Details</p>
                </Link>
            </div>
        </section>
    );
};


export default Booking_Details_Card
// const Booking_Details_Card = ({ data, showTrackOrder, track_order_text, onClick, baseLike, type }) => {
//     return (
//         <section className='Booking_Details_Card' >

//             <div className='top_section'>
//                 <p className='order_id'>Order ID #{data?.order_id}</p>

//                 <div className='date_text_div'>
//                     <p className='date_text'>{data?.date}</p>
//                 </div>
//             </div>

//             <div className='middle_section'>
//                 <p className='black_text'>{data?.item_no} Items</p>

//                 {showTrackOrder && (<p className='track_order_text' onClick={onClick} >{track_order_text}</p>)}
//             </div>

//             <div className='bottom_section'>

//                 <p className='black_text'>₹.{data?.price} <span className={`${type} subtext`}>{data?.subtext}</span></p>
//                 <Link to={baseLike}>
//                     <p className='view_details_text'>View Details</p>
//                 </Link>

//             </div>

//         </section>
//     )
// }

// export default Booking_Details_Card
